
<c-app-content
    :hide-top    = "true"
    @initialized = "onInitialized"
>
    <template v-slot:content>
        <d-site
            v-model  = "unit.show"
            :site-id = "unit.id"
        />

        <div
            id    = "site-search-panel"
            class = "overview-panel v-flex"
            :key  = "count"
        >
            <m-site-overview-menu
                @download = "onDownload"
                @refresh  = "onRefresh"
            />
            <div>
                <table id="site-table" class="table table-hover table-bordered">
                    <thead>
                    <tr class="table-header">
                        <th class="text-center">
                            <v-table-header-cell
                                group   ="msd.overview.header"
                                first   = "lgsmart"
                                second  = "dms"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center">
                            <v-table-header-cell
                                group   ="msd.overview.header"
                                first   = "fabricNo"
                                second  ="id"
                                v-model = "sort"
                            />
                        </th>
                        <th class="text-center">
                            <v-table-header-cell
                                group   ="msd.overview.header"
                                first   = "customer"
                                second  ="group"
                                :sortable="{ first: true, second: false }"
                                v-model = "sort"
                            />
                        </th>
                        <th class="text-center">
                            <v-table-header-cell
                                group   ="msd.overview.header"
                                first   = "ve"
                                second  ="ve2"
                                v-model = "sort"
                            />
                        </th>
                        <th class="text-center">
                            <v-table-header-cell
                                group   ="msd.overview.header"
                                first   = "ve3"
                                second  ="branch"
                                v-model = "sort"
                            />
                        </th>
                        <th class="text-center">
                            <v-table-header-cell
                                group   ="msd.overview.header"
                                first   = "street"
                                second  ="city"
                                v-model = "sort"
                            />
                        </th>

                        <th class="text-center" style="padding-bottom: 10px!important;">Hersteller<br>BJ Tragkr. HS  ZS</th>
                        <th class="text-center">Geschw.</th>
                        <th class="text-center">Aufzugsart<br>Antriebsart</th>
                        <th class="text-center">Status<br>LM</th>
                        <th class="text-center">Wartungsnehmer<br>Wartungsart</th>
                        <th class="text-center">Aktuell?<br>Endet am</th>
                        <th class="text-center">Notrufnehmer<br>Notrufart</th>
                        <th class="text-center" style="border-right: 0">Aktuell?<br>Endet am</th>
                        <th class="text-center" style="border-right: 0"></th>
                    </tr>
                    </thead>
                </table>
            </div>
        </div>
    </template>
</c-app-content>
